import { RootState } from 'app/store';
import {
  areAnyAccordionsOpen,
  openAccordion
} from 'common/components/accordion/accordionSlice';
import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const AccordionGroup: FC<{
  accordionIds: string[];
  children: JSX.Element | JSX.Element[] | undefined;
}> = ({ accordionIds, children }) => {
  const dispatch = useDispatch();
  const areAnyPageAccordionsOpen = useSelector((state: RootState) =>
    areAnyAccordionsOpen(state, accordionIds)
  );

  const useMountEffect = () =>
    useEffect(() => {
      if (!areAnyPageAccordionsOpen) {
        dispatch(openAccordion({ componentId: accordionIds[0] }));
      }
    }, []);

  useMountEffect();

  return <div className="">{children}</div>;
};

export default AccordionGroup;
